import * as React from 'react';
import {Shop} from 'interfaces';

import DesktopNewTabAnchor from 'components/DesktopNewTabAnchor';

export interface Props {
  shop: Shop;
}

export default function ShopAskingPrice(props: Props) {
  return (
    <DesktopNewTabAnchor href={`/shops/${props.shop.handle}`}>
      <div className="shop-tile__price">
        <span className="currency-symbol">$</span>
        {props.shop.salePrice.toLocaleString('en-US',
          {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          })}
        <span className="currency-name">USD</span>
      </div>
    </DesktopNewTabAnchor>
  );
}
